import { Badge } from "@/components/ui-kit";

const ORD = ["", "First", "Second", "Third", "Fourth", "Fifth", "Sixth"];

export const cycleText = (n) => `${ORD[n] || `${n}th`} cycle of therapy`;

export function CycleBadge({ cycle, testid }) {
  if (!cycle || cycle < 2) return null;
  return <span data-testid={testid}><Badge tone="sky">{cycleText(cycle)}</Badge></span>;
}

export const sessionsLabel = (oc = {}) =>
  oc.sessions_total > 0 ? `${oc.sessions_completed || 0}/${oc.sessions_total} sessions` : `${oc.sessions_completed || 0} sessions · total not set`;

export const ratio = (oc = {}) => `${oc.sessions_completed || 0}/${oc.sessions_total > 0 ? oc.sessions_total : "—"}`;

export const reportSessionText = (r = {}) =>
  `${r.session_no}${r.sessions_total > 0 ? ` of ${r.sessions_total}` : ""}${r.cycle > 1 ? ` · ${cycleText(r.cycle)}` : ""}`;

export const nextSessionNo = (oc = {}) =>
  oc.sessions_total > 0 ? Math.min(oc.sessions_total, (oc.sessions_completed || 0) + 1) : (oc.sessions_completed || 0) + 1;

export function CycleHistory({ h, testid }) {
  if (!h || !h.cycles || h.cycles.length < 2) return null;
  return (
    <div className="text-[11.5px] font-semibold text-sky-800" data-testid={testid}>
      Cycle count: <span data-testid={`${testid}-count`}>{h.cycles.length}</span>
    </div>
  );
}
